<template>
  <vue-tags-input
    class="emails-input"
    v-model="tag"
    :tags="tags"
    @tags-changed="onChange"
    :placeholder="$t('email.add')"
    :validation="validation"
  />
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { validate } from 'email-validator';

export default {
  components: {
    VueTagsInput,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Array,
  },
  computed: {
    validation() {
      return [
        {
          classes: 'invalid-value',
          rule({ text }) {
            return !validate(text);
          },
          disableAdd: true,
        },
      ];
    },
  },
  data() {
    return {
      tag: '',
      tags: [],
    };
  },
  methods: {
    onChange(newTags) {
      this.tags = newTags;
      const values = newTags.map((i) => i.text);

      this.$emit('change', values);
    },
  },
};
</script>

<style lang="scss">
.emails-input .ti-input {
  border-radius: 4px;
}
</style>